import { get_session9cytjmfbg8nd as get_session } from '../../../sdk/UserSession.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { NotFoundikk4a5uq9edp as NotFound } from '../../../sdk/errors.mjs';
import { AnonymousProjectInfo3pqkdqm16et5a as AnonymousProjectInfo } from '../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { toSet2orjxp16sotqu as toSet } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { hash2t85n3abss7t0 as hash } from '../../../../../../crowpay-shared/com/crowpay/extensions/Project.ext.mjs';
import { ModificationBuilderuhgnvnxpchbi as ModificationBuilder } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/ModificationBuilder.mjs';
import {
  User8yb1tqk4kykg as User,
  Type_ClientTermsAndConditions_getInstance2f0qgbe5c0m6j as Type_ClientTermsAndConditions_getInstance,
} from '../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import { get_viewingAnonymousProjects1fofp0ylcs0e6 as get_viewingAnonymousProjects } from '../../../../../../crowpay-shared/com/crowpay/UserFields.mjs';
import { get_pageNavigator1inl9j7ja0vlf as get_pageNavigator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { ClientProjectsuhqipbst20fz as ClientProjects } from './ClientProjects.mjs';
import { ClientProject3d3kef0q1hn13 as ClientProject } from './ClientProject.mjs';
import {
  intercepted2ogpsikxxj4u0 as intercepted,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CancellableContinuationImpl.mjs';
import { get_dialogStackleaqvayyucjw as get_dialogStack } from '../../components/nav/crowpay.mjs';
import { GenericDialog2kroovzplfo3s as GenericDialog } from '../../dialogs/GenericDialog.mjs';
import { returnIfSuspendedqak8u4r448cu as returnIfSuspended } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coroutineInternalJS.mjs';
import { LsErrorException1ikb4g50zc2ko as LsErrorException } from '../../../../../../lightning-server-kiteui-client/com/lightningkite/lightningserver/LsErrorException.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  initMetadataForFunctionReferencen3g5fpj34t8u as initMetadataForFunctionReference,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  Companion_instance2oawqq9qiaris as Companion_instance,
  _Result___init__impl__xyqfz83hut4nr3dfvi3 as _Result___init__impl__xyqfz8,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { ViewWriter2xfqkrnuqv5cx as ViewWriter } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/ViewWriter.mjs';
import { LandingScreennv9edtrim3be as LandingScreen } from '../common/LandingScreen.mjs';
import { AgreementData1bovrwm0h7gbm as AgreementData } from '../../../utils/AgreementData.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../components/nav/AppDimensions.mjs';
import {
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
  get_scrolling27q1yr4ng0cx8 as get_scrolling,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  get_centered1xfu6or5nc0lq as get_centered,
  get_expanding10cuv3ua9vajx as get_expanding,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  title1nssp3ryhwuqj as title,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  body3i5t0n7zprpqb as body,
} from '../../theming/Titles.mjs';
import { get_waitForNotNull1jl9mx6el51tq as get_waitForNotNull } from '../../../../../../reactive/com/lightningkite/reactive/extensions/WaitForNotNull.mjs';
import { exportCrowPayLegalDocument31qdjr0k7gqoi as exportCrowPayLegalDocument } from '../../dialogs/emailDocumentDialog.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { html1nvxkcfsy8qu3 as html } from '../../../utils/utils.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { Checkbox2he0oy51inwu6 as Checkbox } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Checkbox.commonHtml.mjs';
import { ButtonSemantic_getInstance2exl8jbak13ac as ButtonSemantic_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
  get_textButtonybbt8y3eu5hx as get_textButton,
} from '../../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_render$acceptProject__8puj23(agreement, this$0, $this_render, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  var tmp_0 = agreement.dfz($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  try {
    var tmp0_elvis_lhs = this$0.nf8_1;
    var tmp_1;
    if (tmp0_elvis_lhs == null) {
      throw NotFound().pfx(getKClass(AnonymousProjectInfo()), null);
    } else {
      tmp_1 = tmp0_elvis_lhs;
    }
    var info = tmp_1;
    var tmp_2 = session.vfw().rfg_1.ifp(info.w9w_1.v7a_1, hash(info.w9w_1, toSet(info.z9w_1)), $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    // Inline function 'com.crowpay.utils.modify2' call
    var this_1 = session.afw_1.geo(session.gfv_1);
    // Inline function 'com.lightningkite.lightningdb.modification' call
    // Inline function 'kotlin.apply' call
    var this_2 = new (ModificationBuilder())();
    // Inline function 'com.lightningkite.lightningdb.path' call
    // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
    var tmp_3 = serializerOrContextual(createKType(getKClass(User()), arrayOf([]), false));
    var tmp$ret$1 = isInterface(tmp_3, KSerializer()) ? tmp_3 : THROW_CCE();
    var it = new (DataClassPathSelf())(tmp$ret$1);
    this_2.f44(get_viewingAnonymousProjects(it), info.w9w_1.v7a_1);
    var tmp$ret$6 = this_2.m1r();
    var tmp_4 = this_1.nen(tmp$ret$6, $completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
    get_pageNavigator($this_render).gbw(new (ClientProjects())());
    get_pageNavigator($this_render).fbw(new (ClientProject())(this$0.mf8_1));
  } catch ($p) {
    if ($p instanceof LsErrorException()) {
      var _unused_var__etf5q3 = $p;
      // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
      // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
      var cancellable = new (CancellableContinuationImpl())(intercepted($completion), 1);
      cancellable.ta5();
      var tmp_5 = get_dialogStack();
      tmp_5.zgd(GenericDialog().bgz('Accepting failed. You may be viewing old data. Refresh the page and try again. If the problem persists contact support.', ClientTermsAndServices$render$acceptProject$slambda_0(cancellable)));
      var tmp$ret$9 = cancellable.ua5();
      var tmp_6 = returnIfSuspended(tmp$ret$9, $completion);
      if (tmp_6 === get_COROUTINE_SUSPENDED())
        tmp_6 = yield tmp_6;
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function render$acceptProject(agreement, this$0, $this_render, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_render$acceptProject__8puj23.bind(VOID, agreement, this$0, $this_render), $completion);
}
function Button$_get_enabled_$ref_61t7nx(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
var ClientTermsAndServices$render$acceptProject$refClass;
function ClientTermsAndServices$render$acceptProject$ref() {
  if (ClientTermsAndServices$render$acceptProject$refClass === VOID) {
    class $ {
      constructor($agreement, this$0, $this_render) {
        this.wj3_1 = $agreement;
        this.xj3_1 = this$0;
        this.yj3_1 = $this_render;
      }
      uao($completion) {
        return render$acceptProject(this.wj3_1, this.xj3_1, this.yj3_1, $completion);
      }
    }
    initMetadataForFunctionReference($, VOID, VOID, [0]);
    ClientTermsAndServices$render$acceptProject$refClass = $;
  }
  return ClientTermsAndServices$render$acceptProject$refClass;
}
function ClientTermsAndServices$render$acceptProject$ref_0($agreement, this$0, $this_render) {
  var i = new (ClientTermsAndServices$render$acceptProject$ref())($agreement, this$0, $this_render);
  var l = ($completion) => i.uao($completion);
  l.callableName = 'acceptProject';
  l.$arity = 0;
  return l;
}
var ClientTermsAndServices$render$slambdaClass;
function ClientTermsAndServices$render$slambda() {
  if (ClientTermsAndServices$render$slambdaClass === VOID) {
    class $ {
      constructor($$this$button) {
        this.zj3_1 = $$this$button;
      }
      uao($completion) {
        get_pageNavigator(this.zj3_1).sd6();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ClientTermsAndServices$render$slambdaClass = $;
  }
  return ClientTermsAndServices$render$slambdaClass;
}
function ClientTermsAndServices$render$slambda_0($$this$button) {
  var i = new (ClientTermsAndServices$render$slambda())($$this$button);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var ClientTermsAndServices$render$acceptProject$slambdaClass;
function ClientTermsAndServices$render$acceptProject$slambda() {
  if (ClientTermsAndServices$render$acceptProject$slambdaClass === VOID) {
    class $ {
      constructor($cont) {
        this.aj4_1 = $cont;
      }
      ygg($this$GenericDialog, $completion) {
        // Inline function 'kotlin.coroutines.resume' call
        var this_0 = this.aj4_1;
        // Inline function 'kotlin.Companion.success' call
        var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
        this_0.rc(tmp$ret$0);
        get_dialogStack().pgd();
      }
      s2(p1, $completion) {
        return this.ygg(p1 instanceof ViewWriter() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ClientTermsAndServices$render$acceptProject$slambdaClass = $;
  }
  return ClientTermsAndServices$render$acceptProject$slambdaClass;
}
function ClientTermsAndServices$render$acceptProject$slambda_0($cont) {
  var i = new (ClientTermsAndServices$render$acceptProject$slambda())($cont);
  var l = ($this$GenericDialog, $completion) => i.ygg($this$GenericDialog, $completion);
  l.$arity = 1;
  return l;
}
var ClientTermsAndServicesClass;
function ClientTermsAndServices() {
  if (ClientTermsAndServicesClass === VOID) {
    class $ {
      constructor(projectId) {
        this.mf8_1 = projectId;
        this.nf8_1 = null;
      }
      wd6(_this__u8e3s4) {
        if (this.nf8_1 == null) {
          get_pageNavigator(_this__u8e3s4).fbw(new (LandingScreen())());
        }
        var agreement = new (AgreementData())(Type_ClientTermsAndConditions_getInstance());
        var tmp = sizeConstraints(_this__u8e3s4, VOID, VOID, VOID, VOID, VOID, get_AppDimensions().gg2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.zbm(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view_0.zbm(false);
        view_0.lbb(get_centered(view_0), title(view_0, 'Terms of Service'));
        view_0.lbb(get_centered(view_0), exportCrowPayLegalDocument(view_0, get_waitForNotNull(agreement.xfy_1)));
        view.hbb(p_0, view_0);
        var tmp_0 = view.kbb(get_scrolling(view), get_expanding(view));
        // Inline function 'com.crowpay.views.theming.body' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (TextView())(view.pc());
        var tmp0_elvis_lhs_1 = view.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
        view.gbb(p_1, view_1);
        view_1.lba(view_1.qb6_1.abf(BodySemantic_getInstance()));
        html(view_1, ($this$html) => $this$html.eaj(agreement.xfy_1).b5v_1);
        view.hbb(p_1, view_1);
        view.lbb(tmp_0, view_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (Space())(view.pc());
        var tmp0_elvis_lhs_2 = view.ebb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
        view.gbb(p_2, view_2);
        view.hbb(p_2, view_2);
        var agreed = Signal().hak(false);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_3 = view.ebb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
        view.gbb(p_3, view_3);
        view_3.zbm(false);
        var tmp_1 = get_centered(view_3);
        // Inline function 'com.lightningkite.kiteui.views.direct.checkbox' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (Checkbox())(view_3.pc());
        var tmp0_elvis_lhs_4 = view_3.ebb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
        view_3.gbb(p_4, view_4);
        view_4.zah(view_4.ebk_1, agreed);
        view_3.hbb(p_4, view_4);
        view_3.lbb(tmp_1, view_4);
        view_3.lbb(get_centered(view_3), body(view_3, 'I agree to the terms of service as stated above.'));
        view.hbb(p_3, view_3);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_5 = view.ebb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view : tmp0_elvis_lhs_5;
        view.gbb(p_5, view_5);
        view_5.zbm(false);
        view_5.bb9(get_AppDimensions().kg2_1);
        // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
        var tmp$ret$19 = view_5.jbb(ButtonSemantic_getInstance());
        var tmp_2 = view_5.kbb(tmp$ret$19, get_primaryButton(view_5));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (Button())(view_5.pc());
        var tmp0_elvis_lhs_6 = view_5.ebb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
        view_5.gbb(p_6, view_6);
        var tmp_3 = KMutableProperty0();
        var tmp_4 = Button$_get_enabled_$ref_61t7nx(view_6);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_0 = getPropertyCallableRef('enabled', 0, tmp_3, tmp_4, Button$_set_enabled_$ref_o8kynz(view_6));
        reactiveScope(view_6, ($this$reactiveScope) => {
          var tmp$ret$20 = $this$reactiveScope.daj(agreed);
          this_0.set(tmp$ret$20);
          return Unit_instance;
        });
        specCenteredText(view_6, 'Accept Terms');
        onClick(view_6, VOID, VOID, ClientTermsAndServices$render$acceptProject$ref_0(agreement, this, _this__u8e3s4));
        view_5.hbb(p_6, view_6);
        view_5.lbb(tmp_2, view_6);
        var tmp_5 = get_textButton(view_5);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_7 = new (Button())(view_5.pc());
        var tmp0_elvis_lhs_7 = view_5.ebb_1;
        var p_7 = tmp0_elvis_lhs_7 == null ? view_5 : tmp0_elvis_lhs_7;
        view_5.gbb(p_7, view_7);
        body(view_7, 'Go Back');
        onClick(view_7, VOID, VOID, ClientTermsAndServices$render$slambda_0(view_7));
        view_5.hbb(p_7, view_7);
        view_5.lbb(tmp_5, view_7);
        view.hbb(p_5, view_5);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_8 = new (Space())(view.pc(), 2.0);
        var tmp0_elvis_lhs_8 = view.ebb_1;
        var p_8 = tmp0_elvis_lhs_8 == null ? view : tmp0_elvis_lhs_8;
        view.gbb(p_8, view_8);
        view.hbb(p_8, view_8);
        _this__u8e3s4.hbb(p, view);
        return _this__u8e3s4.lbb(tmp, view);
      }
    }
    protoOf($).wcv = get_title;
    initMetadataForClass($, 'ClientTermsAndServices', VOID, VOID, [Page()], [3]);
    ClientTermsAndServicesClass = $;
  }
  return ClientTermsAndServicesClass;
}
//region block: exports
export {
  ClientTermsAndServices as ClientTermsAndServicesuocndg7xpxyw,
};
//endregion

//# sourceMappingURL=ClientTermsAndServices.mjs.map
